var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172068",
    "data-name": "Group 172068",
    transform: "translate(-8942 18367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 20,
    height: 20,
    transform: "translate(8942 -18367)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_172067",
    "data-name": "Group 172067",
    transform: "translate(8945.999 -18364.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-pdf-645094",
    d: "M175.336,50.415v1.5h-.75v-1.5h-2.25a.75.75,0,0,1-.75-.75v-2.25h-7.5v4.5h-.75v-4.5a.75.75,0,0,1,.75-.75h7.5a.749.749,0,0,1,.532.217l3,3a.75.75,0,0,1,.218.532Zm-.75,10.5h-10.5v-.75h-.75v.75a.75.75,0,0,0,.75.75h10.5a.75.75,0,0,0,.75-.75v-.75h-.75Z",
    transform: "translate(-163.336 -46.666)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21008",
    "data-name": "Path 21008",
    d: "M26.75,14V11H26v3.75h2.25V14Z",
    transform: "translate(-16.25 -3.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21009",
    "data-name": "Path 21009",
    d: "M19.625,11h-.75l-.562,1.5L17.75,11H17v3.75h.75V12.125l.563,1.5.562-1.5V14.75h.75Z",
    transform: "translate(-10.625 -3.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21010",
    "data-name": "Path 21010",
    d: "M9,11.75h.75v3h.75v-3h.75V11H9Z",
    transform: "translate(-5.625 -3.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21011",
    "data-name": "Path 21011",
    d: "M1.875,11v1.5H.75V11H0v3.75H.75v-1.5H1.875v1.5h.75V11Z",
    transform: "translate(0 -3.499)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlFile);
export default __webpack_public_path__ + "static/media/HTML-File.2ede06f29a15a7f49e5c8c33e3a3e481.svg";
export { ForwardRef as ReactComponent };